import { render, staticRenderFns } from "./List.vue?vue&type=template&id=4a14f766&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a14f766')) {
      api.createRecord('4a14f766', component.options)
    } else {
      api.reload('4a14f766', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=4a14f766&", function () {
      api.rerender('4a14f766', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ClientLocation/List.vue"
export default component.exports